import { render, staticRenderFns } from "./MarketingCommissionDetil.vue?vue&type=template&id=55d783ab&"
import script from "./MarketingCommissionDetil.vue?vue&type=script&lang=ts&"
export * from "./MarketingCommissionDetil.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports